import { FontInfo } from "../../utils/FontInfo";
import { Pool } from "../../utils/Pool";
import { WordText } from "../../utils/WordText";
import { ILaya } from "../../../ILaya";
import { Const } from "../../Const";
import { ClassUtils } from "../../utils/ClassUtils";
import { Config } from "../../../Config";
import { Rectangle } from "../../maths/Rectangle";
export class FillTextCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
        this._strokeColor = '#000000';
        this._loosyBound = null;
    }
    get text() {
        return this._text;
    }
    set text(value) {
        this._text = value;
    }
    get strokeColor() {
        return this._strokeColor;
    }
    set strokeColor(value) {
        this._strokeColor = value;
    }
    get stroke() {
        return this._stroke;
    }
    set stroke(value) {
        this._stroke = value;
    }
    get align() {
        return this._align;
    }
    set align(value) {
        this._align = value;
    }
    static create(text, x, y, font, color, align, stroke, strokeColor) {
        var cmd = Pool.getItemByClass("FillTextCmd", FillTextCmd);
        cmd._text = null;
        cmd._wordText = null;
        cmd.x = x;
        cmd.y = y;
        cmd.font = font;
        cmd.color = color;
        cmd._stroke = stroke;
        cmd._strokeColor = strokeColor;
        switch (align) {
            case 'center':
                cmd._align = Const.ENUM_TEXTALIGN_CENTER;
                break;
            case 'right':
                cmd._align = Const.ENUM_TEXTALIGN_RIGHT;
                break;
            default:
                cmd._align = Const.ENUM_TEXTALIGN_DEFAULT;
        }
        if (text instanceof WordText) {
            cmd._wordText = text;
            text.cleanCache();
        }
        else
            cmd._text = text;
        return cmd;
    }
    recover() {
        Pool.recover("FillTextCmd", this);
    }
    run(context, gx, gy) {
        if (ILaya.stage.isGlobalRepaint()) {
            this._wordText && this._wordText.cleanCache();
        }
        if (null == this._text)
            this._text = '';
        if (null == this._fontObj) {
            this.font = null;
        }
        if (null == this._color) {
            this._color = '#ffffff';
        }
        context._fast_filltext(this._wordText || this._text, this.x + gx, this.y + gy, this._fontObj, this._color, this._strokeColor, this._stroke, this._align);
    }
    get cmdID() {
        return FillTextCmd.ID;
    }
    get font() {
        return this._font;
    }
    set font(value) {
        this._font = value;
        if (!value)
            value = Config.defaultFontSize + "px " + Config.defaultFont;
        this._fontObj = FontInfo.parse(value);
        this._wordText && this._wordText.cleanCache();
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this._wordText && this._wordText.cleanCache();
    }
    getBounds(assembler) {
        if (!this._loosyBound) {
            let ctx = ILaya.Browser.context;
            ctx.save();
            ctx.font = this.font;
            let size = ctx.measureText(this.text);
            let w = size.width;
            ctx.restore();
            let x = this.x;
            let y = this.y;
            switch (this._align) {
                case Const.ENUM_TEXTALIGN_CENTER:
                    x -= w / 2;
                    break;
                case Const.ENUM_TEXTALIGN_RIGHT:
                    x -= w;
                    break;
                default:
                    break;
            }
            if (!this._fontObj)
                this.font = null;
            x -= 4;
            y -= this._fontObj._size;
            this._loosyBound = new Rectangle(x, y, w + 8, this._fontObj._size * 2);
        }
        Rectangle.TEMP.setTo(this._loosyBound.x, this._loosyBound.y, this._loosyBound.width, this._loosyBound.height).getBoundPoints(assembler.points);
    }
}
FillTextCmd.ID = "FillText";
ClassUtils.regClass("FillTextCmd", FillTextCmd);
